<template>
  <div>
    <h1>Post Promotion</h1>
    <br />
    <br />
    <div class="adres-select-types">
      <h2>1. Select target location</h2>
      <b-tabs>
        <b-tab
          title="By City"
          :active="coordType == 'city'"
          @click="onChangeTab('city')"
        >
          <b-row>
            <b-col sm="1"><label :for="city">City:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="city"
                v-model="city"
                type="text"
                placeholder="Enter city"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="country">Country:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="country"
                v-model="country"
                type="text"
                placeholder="Enter country"
              ></b-form-input
            ></b-col>
          </b-row>
        </b-tab>
        <b-tab
          title="By Zip"
          :active="coordType == 'zip'"
          @click="onChangeTab('zip')"
        >
          <b-row>
            <b-col sm="1"><label :for="zip">Zip:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="zip"
                v-model="zip"
                type="text"
                placeholder="Enter zip"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="country">Country:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="country"
                v-model="country"
                type="text"
                placeholder="Enter country"
              ></b-form-input
            ></b-col>
          </b-row>
        </b-tab>
        <b-tab
          title="By Address"
          :active="coordType == 'address'"
          @click="onChangeTab('address')"
        >
          <b-row>
            <b-col sm="1"><label :for="street">Street:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="street"
                v-model="street"
                type="text"
                placeholder="Enter street"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="city">City:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="city"
                v-model="city"
                type="text"
                placeholder="Enter city"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="state">State:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="state"
                v-model="state"
                type="text"
                placeholder="Enter state"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="zip">Zip:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="zip"
                v-model="zip"
                type="text"
                placeholder="Enter zip"
              ></b-form-input
            ></b-col>
          </b-row>
          <b-row>
            <b-col sm="1"><label :for="country">Country:</label></b-col>
            <b-col sm="11"
              ><b-form-input
                id="country"
                v-model="country"
                type="text"
                placeholder="Enter country"
              ></b-form-input
            ></b-col>
          </b-row>
          <h6>Radius</h6>
          <br />
          <br />
          <b-row>
            <b-col>
              <vue-slider
                ref="addrSlider"
                v-model="addrRadius"
                :min="1"
                :max="5.205"
                :interval="0.001"
                :tooltip="'always'"
                :marks="radiusMarksFormatter"
                :tooltip-formatter="formatterM"
              ></vue-slider>
            </b-col>
          </b-row>
          <br />
          <br />
        </b-tab>
        <b-tab
          title="By Map"
          :active="coordType == 'map'"
          @click="onChangeTab('map')"
        >
          <GmapMap
            ref="themap"
            :zoom="13"
            style="width:40vh;  height: 40vh;"
            :center="mapCenter"
            @idle="updateBounds"
          >
            <GmapCircle
              :center="mapCenter"
              :radius="mapRadius"
              :visible="true"
              :options="{ fillColor: 'red', fillOpacity: 0.03 }"
            ></GmapCircle>
          </GmapMap>
        </b-tab>
      </b-tabs>
    </div>

    <div>
      <h2>2. Select time window people were there</h2>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>Start</h4>
        <b-row>
          <b-col sm="1">Date:</b-col>
          <b-col sm="11" style="margin: 0 0 35px 0;">
            <datetime v-model="startDateD" type="date"></datetime>
          </b-col>
        </b-row>
        <b-row>
          <b-col>Time:<br /><br /></b-col>
        </b-row>
        <b-row>
          <b-col>
            <vue-slider
              v-model="timeFrom.h"
              :min="0"
              :max="24"
              :tooltip="'always'"
              :interval="1"
              :tooltip-formatter="formatterH"
              :marks="timeMarksFormatter"
            ></vue-slider>
          </b-col>
        </b-row>
      </div>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>End</h4>
        <b-row>
          <b-col sm="1">Date:</b-col>
          <b-col sm="11" style="margin: 0 0 35px 0;">
            <datetime v-model="endDateD" type="date"></datetime>
          </b-col>
        </b-row>
        <b-row>
          <b-col>Time:<br /><br /></b-col>
        </b-row>
        <b-row>
          <b-col>
            <vue-slider
              v-model="timeTo.h"
              :min="0"
              :max="24"
              :tooltip="'always'"
              :interval="1"
              :tooltip-formatter="formatterH"
              :marks="timeMarksFormatter"
            ></vue-slider>
          </b-col>
        </b-row>
      </div>
      <b-button variant="warning" @click="datesManagement()"
        >Update Age Range of People There</b-button
      >
      <br />
      <br />
      <br />
    </div>
    <div>
      <h2>3. Select age ranges</h2>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>Male age range</h4>
        <br />
        <b-row>
          <b-col>
            <vue-slider
              ref="manSlider"
              v-model="menAgeRange"
              v-bind="manSlider"
              :tooltip="'always'"
              :marks="manSliderData"
              :lazy="true"
            ></vue-slider>
            <br />
          </b-col>
        </b-row>
      </div>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>Female age range</h4>
        <br />
        <b-row>
          <b-col>
            <vue-slider
              ref="womanSlider"
              v-model="womenAgeRange"
              v-bind="womanSlider"
              :tooltip="'always'"
              :marks="womanSliderData"
            ></vue-slider>
            <br />
          </b-col>
        </b-row>
      </div>
    </div>
    <b-button variant="warning" @click="recipientsCounts()"
      >Update Count of People There</b-button
    >
    <br />
    <br />
    <br />
    <div>
      <h2>4. Select the number of people to reach</h2>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>Number of Males:</h4>
        <br />
        <b-row>
          <b-col>
            <vue-slider
              ref="manNSlider"
              v-model="menRecipientsNumber"
              v-bind="manNSlider"
              :marks="manNSliderData"
              :tooltip="'always'"
            ></vue-slider>
          </b-col>
        </b-row>
        <br />
      </div>
      <div
        style="border: 1px solid #ccc; border-radius: 4px; margin: 0 0 30px 0; padding: 20px"
      >
        <h4>Number of Females:</h4>
        <br />
        <b-row>
          <b-col>
            <vue-slider
              ref="womanNSlider"
              v-model="womenRecipientsNumber"
              v-bind="womanNSlider"
              :marks="womanNSliderData"
              :tooltip="'always'"
            ></vue-slider>
          </b-col>
        </b-row>
        <br />
      </div>
    </div>
    <div>
      <br />
      <h4>
        Once approved, your promo is immediately sent as a phone alert to
        {{ menRecipientsNumber + womenRecipientsNumber }} people and is also
        posted for a month on a map of local deals for them and many others to
        see.
      </h4>
      <h4>
        Promotion cost: ${{ price.toFixed(2) }} plus $0.50 processing fee = ${{
          (price + 0.5).toFixed(2)
        }}
      </h4>
      <br />
      <br />
    </div>
    <div>
      <h2>5. Enter promotion details:</h2>
      <b-form-input
        v-model="advertisment.title"
        type="text"
        placeholder="Title"
        required
      ></b-form-input>
      <b-form-textarea
        v-model="advertisment.text"
        rows="4"
        placeholder="Description"
        required
      />
      <b-form-input
        v-model="advertisment.aEventName"
        type="text"
        placeholder="Advertiser/Event name"
      ></b-form-input>
      <input ref="image" type="file" accept="image/*" @change="onFilePicked" />
      <img v-if="imageUrl" :src="imageUrl" width="320" />
      <h2>
        6. Enter the address where the promotion is to be used, or leave empty
        if no physical address:
      </h2>
      <b-form-input
        v-model="advertisment.aRedeemAddress.street"
        type="text"
        placeholder="Street"
      ></b-form-input>
      <b-form-input
        v-model="advertisment.aRedeemAddress.city"
        type="text"
        placeholder="City"
      ></b-form-input>
      <b-form-input
        v-model="advertisment.aRedeemAddress.zip"
        type="text"
        placeholder="Zip"
      ></b-form-input>
      <b-form-input
        v-model="advertisment.aRedeemAddress.country"
        type="text"
        placeholder="Country"
      ></b-form-input>
    </div>
    <div>
      <h2>7. Enter payment info</h2>
      <b-form-input
        v-model="name"
        type="text"
        placeholder="Name"
      ></b-form-input>
      <b-form-input
        v-model="phone"
        type="text"
        placeholder="Phone number"
      ></b-form-input>
      <b-form-input
        v-model="email"
        type="text"
        placeholder="Email"
      ></b-form-input>
      <b-form-input
        v-model="emailConfirm"
        type="text"
        placeholder="Email confirm"
      ></b-form-input>
      <div v-if="showEmailError" class="error" style="color: red;">
        Email addresses must match
      </div>
      <div class="form-row">
        <div id="card-element">
          <!-- A Stripe Element will be inserted here. -->
        </div>
        <!-- Used to display Element errors. -->
        <div id="card-errors" role="alert"></div>
      </div>
      <div v-if="showCardError" class="error" style="color: red">
        {{ cardError }}<br /><br />
      </div>
    </div>
    <b-button v-if="price > 0" variant="success" @click="createToken()"
      >Submit Promotion</b-button
    >
    <br />
    <br />
    <div v-if="overlay" class="overlay">
      <b-spinner
        variant="warning"
        label="Text Centered"
        style="margin: 45vh 45vw"
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import BRow from 'bootstrap-vue/src/components/layout/row';
import BCol from 'bootstrap-vue/src/components/layout/col';
import { DateTime as LuxonDateTime } from 'luxon';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import BButton from 'bootstrap-vue/src/components/button/button';
import config from '../config';
import Geocoder from '@/geocoder';
import { setTimeout } from 'timers';
export default {
  name: 'Advertiser',
  components: {
    BButton,
    BCol,
    BRow,
    VueSlider
  },
  data: function() {
    return {
      file: '',
      imageUrl: '',
      firstLoad: true,
      overlay: false,
      showCardError: false,
      cardError: null,
      step1complete: true,
      step2complete: false,
      step3complete: false,
      step4complete: false,
      timeHData: [0, 23],
      formatterH: v => {
        if (v < 10) {
          return '0' + v + ':00';
        } else {
          return v + ':00';
        }
      },
      timeHRange: { min: 0, max: 23 },
      timeIRange: { min: 0, max: 59 },
      timeFrom: {
        h: new Date().getHours(),
        i: new Date().getMinutes()
      },
      timeTo: {
        h: new Date().getHours(),
        i: new Date().getMinutes()
      },
      coordType: 'city',
      measures: 'km',
      mapRadius: 0,
      addrRadius: 1,
      mapBounds: {},
      mapCenter: { lat: 40.76523, lng: -73.976034 },
      radius: 2000,
      street: '50 Central Park S',
      city: 'New York',
      state: 'NY',
      country: 'United States',
      price: 0,
      zip: 10019,
      phone: null,
      startDate: new Date(new Date().getTime() - 3600 * 24 * 101 * 1000),
      endDate: new Date(),
      startDateD: LuxonDateTime.local()
        .minus({ days: 31 })
        .toISO(),
      endDateD: LuxonDateTime.local()
        .minus({ days: 1 })
        .toISO(),
      menAgeRange: [10, 90],
      womenAgeRange: [10, 90],
      menRecipientsNumber: 0,
      womenRecipientsNumber: 0,
      manSlider: {
        min: 10,
        max: 90,
        disabled: true
      },
      manSliderData: {
        10: 10,
        90: 90
      },
      womanSlider: {
        min: 10,
        max: 90,
        disabled: true
      },
      womanSliderData: {
        10: 10,
        90: 90
      },
      manNSlider: {
        min: 0,
        max: 100,
        disabled: true
      },
      manNSliderData: {
        0: 0,
        100: '0'
      },
      womanNSlider: {
        min: 0,
        max: 100,
        disabled: true
      },
      womanNSliderData: {
        0: 0,
        100: '0'
      },
      name: '',
      email: '',
      emailConfirm: '',
      stripeCardToken: null,
      stripe: null,
      elements: {},
      timer: 0,
      advertisment: {
        title: null,
        text: null,
        aEventName: null,
        aRedeemAddress: {
          street: null,
          city: null,
          zip: null,
          country: null,
          lat: null,
          lng: null
        },
        photoUuid: null
      },
      showEmailError: false
    };
  },
  watch: {
    menRecipientsNumber: function() {
      this.recalcPrice();
    },
    womenRecipientsNumber: function() {
      this.recalcPrice();
    },
    email: function() {
      this.checkEmails();
    },
    emailConfirm: function() {
      this.checkEmails();
    },
    startDateD: function() {
      this.recalculateStartDate();
    },
    endDateD: function() {
      this.recalculateEndDate();
    },
    timeFrom: {
      handler() {
        this.recalculateStartDate();
      },
      deep: true
    },
    timeTo: {
      handler() {
        this.recalculateEndDate();
      },
      deep: true
    },
    stripeCardToken: function() {
      if (
        !this.advertisment.aRedeemAddress.street &&
        !this.advertisment.aRedeemAddress.city &&
        !this.advertisment.aRedeemAddress.zip &&
        !this.advertisment.aRedeemAddress.country
      ) {
        this.createAd();
      } else {
        Geocoder.requestLocationObj({
          address_line_1: this.advertisment.aRedeemAddress.street,
          address_line_2: '',
          city: this.advertisment.aRedeemAddress.city,
          zip_code: this.advertisment.aRedeemAddress.zip,
          country: this.advertisment.aRedeemAddress.country
        })
          .then(res => {
            if (res.data) {
              res = res.data.result;
              this.advertisment.aRedeemAddress.lat = res.geometry.location.lat;
              this.advertisment.aRedeemAddress.lng = res.geometry.location.lng;
            }
            this.createAd();
          })
          .catch(err => {
            console.log(err);
            this.overlay = false;
          });
      }
    }
  },
  mounted() {
    this.$getLocation()
      .then(coordinates => {
        this.calculateMap();
        this.mapCenter = coordinates;
        Geocoder.request({
          lat: coordinates.lat,
          lng: coordinates.lng
        }).then(result => {
          if (!result.data) {
            return;
          }
          result = result.data.result;
          API.get('https://api.ipify.org?format=json', {}, true).then(res => {
            if (res.status === 200) {
              API.post('user/adv-myip', res.data, true).then(res => {
                if (res.status === 'ok') {
                  if (res.data.countryCode === 'US') {
                    this.measures = 'mil';
                  }
                }
              });
            }
          });
          // if (result.types.indexOf('street_address') < 0 || result.geometry.location_type !== 'RANGE_INTERPOLATED') return
          let streetAddress = [];
          result.address_components.forEach(component => {
            if (component.types.indexOf('postal_code') > -1) {
              this.zip = component.short_name;
            }
            if (component.types.indexOf('country') > -1) {
              this.country = component.long_name;
            }
            if (component.types.indexOf('administrative_area_level_1') > -1) {
              this.state = component.long_name;
            }
            if (component.types.indexOf('locality') > -1) {
              this.city = component.long_name;
            }
            if (component.types.indexOf('street_number') > -1) {
              streetAddress.push(component.long_name);
            }
            if (component.types.indexOf('route') > -1) {
              streetAddress.push(component.long_name);
            }
          });
          this.street = streetAddress.join(', ');
        });
      })
      .catch(e => {
        console.log(e);
        this.overlay = true;
        var clone = Object.assign({}, this.$data);
        delete clone.file;
        API.post(`user/adv-search`, clone)
          .then(res => {
            this.processResponse(res);
            this.overlay = false;
          })
          .catch(err => {
            console.log(err);
            this.overlay = false;
          });
      });
    if (window.Stripe === undefined) {
      alert('Stripe V3 library not loaded!');
    } else {
      let style = {
        base: {
          fontSize: '16px',
          color: '#32325d'
        }
      };
      this.stripe = window.Stripe(config.stripePublicKey());
      let elements = this.stripe.elements();
      this.card = elements.create('card', { style: style });
      this.card.mount('#card-element');
    }
  },

  methods: {
    async createAd() {
      try {
        debugger;
        if (this.file != '') {
          this.advertisment.photoUuid = await this.submitFile();
        }
        this.overlay = true;
        this.cardError = null;
        this.showCardError = false;
        let res = await API.post(`advertisment/create`, {
          measures: this.measures,
          name: this.name,
          email: this.email,
          stripeCardToken: this.stripeCardToken,
          coordType: this.coordType,
          mapCenter: this.mapCenter,
          radius: this.radius / 1000,
          street: this.street,
          city: this.city,
          state: this.state,
          country: this.country,
          zip: this.zip,
          startDate: this.startDate,
          endDate: this.endDate,
          startDateText: this.startDate.toTimeString(),
          endDateText: this.endDate.toTimeString(),
          price: this.price,
          phone: this.phone,
          menAgeRange: this.menAgeRange,
          womenAgeRange: this.womenAgeRange,
          menRecipientsNumber: this.menRecipientsNumber,
          womenRecipientsNumber: this.womenRecipientsNumber,
          advertisment: this.advertisment
        });
        if (res.status === 'error') {
          this.overlay = false;
          let errors = [];
          res.errors.forEach(error => {
            errors.push(error.msg);
          });
          this.cardError = errors.join('; ');
          this.showCardError = true;
        } else {
          this.overlay = false;
          alert(
            'Thank you for submitting your promotion. It will be reviewed in short order.'
          );
          location.reload();
        }
      } catch (err) {
        console.log(err);
        this.overlay = false;
      }
    },
    formatterM(v, digits) {
      if (typeof digits === 'undefined') {
        digits = 2;
      }
      let realV = Math.pow(10, v);
      if (this.measures === 'km') {
        if (realV < 1000) {
          return realV.toFixed(digits) + ' m';
        } else {
          return (realV / 1000).toFixed(digits) + ' KM';
        }
      } else {
        if (realV < 1600) {
          return (realV * 3.28084).toFixed(digits) + ' ft';
        }
        return (realV / 1.6 / 1000).toFixed(digits) + ' miles';
      }
    },
    radiusMarksFormatter(v) {
      if (v === 1 || v === 5.205) {
        return { label: this.formatterM(v, 0) };
      }
    },
    timeMarksFormatter(v) {
      if (v === 0 || v === 24) {
        if (v < 10) {
          return { label: '0' + v + ':00' };
        }
        return { label: v + ':00' };
      }
    },
    recalculateStartDate() {
      let date = new Date(this.startDateD);
      if (this.timeFrom.h === 24) {
        date.setHours(23);
        date.setMinutes(59);
      } else {
        date.setHours(this.timeFrom.h);
        date.setMinutes(this.timeFrom.i);
      }
      this.startDate = date;
    },
    recalculateEndDate() {
      let date = new Date(this.endDateD);
      if (this.timeTo.h === 24) {
        date.setHours(23);
        date.setMinutes(59);
      } else {
        date.setHours(this.timeTo.h);
        date.setMinutes(this.timeTo.i);
      }
      this.endDate = date;
    },
    checkEmails() {
      if (this.email.length === 0 || this.email !== this.emailConfirm) {
        this.showEmailError = true;
      } else {
        this.showEmailError = false;
      }
    },
    createToken() {
      this.checkEmails();
      if (this.showEmailError) {
        return;
      }
      if (window.Stripe === undefined) {
        alert('Stripe V3 library not loaded!');
      } else {
        let $this = this;
        if (this.overlay) return;
        this.overlay = true;
        this.showCardError = false;
        this.cardError = null;
        this.stripe
          .createToken(this.card)
          .then(res => {
            if (res.error) {
              $this.cardError = res.error.message;
              $this.showCardError = true;
              $this.overlay = false;
              return;
            }
            this.stripeCardToken = res.token.id;
          })
          .catch(err => {
            console.log(err);
            this.overlay = false;
          });
      }
    },
    recalcPrice() {
      let price = parseFloat(
        (
          (this.womenRecipientsNumber + this.menRecipientsNumber) *
          0.05
        ).toFixed(2)
      );
      if (price < 1 && price > 0) {
        this.price = 1;
      } else {
        this.price = price;
      }
    },
    recipientsCounts() {
      this.overlay = true;
      var clone = Object.assign({}, this.$data);
      delete clone.file;
      API.post(`user/adv-search`, clone)
        .then(res => {
          this.recalcManNSlider(res.data);
          this.recalcWomanNSlider(res.data);
          this.overlay = false;
        })
        .catch(err => {
          console.log(err);
          this.overlay = false;
        });
    },
    datesManagement() {
      this.overlay = true;
      switch (this.coordType) {
        case 'map':
          this.calculateMap();
          this.radius = this.mapRadius;
          if (
            this.country === 'USA' ||
            this.country === 'US' ||
            this.country === 'United States of America'
          ) {
            this.country = 'United States';
          }
          var clone = Object.assign({}, this.$data);
          delete clone.file;
          API.post(`user/adv-search`, clone)
            .then(res => {
              this.processResponse(res);
            })
            .catch(err => {
              console.log(err);
              this.overlay = false;
            });
          break;
        case 'address':
          this.radius = Math.pow(10, this.addrRadius);
          this.processAddrForm();
          break;
        case 'zip':
        case 'city':
          this.processZipCity();
          break;
      }
    },
    processZipCity() {
      var clone = Object.assign({}, this.$data);
      delete clone.file;
      API.post(`user/adv-search`, clone)
        .then(res => {
          this.processResponse(res);
        })
        .catch(err => {
          console.log(err);
          this.overlay = false;
        });
    },
    processAddrForm() {
      Geocoder.requestLocationObj({
        address_line_1: this.street,
        address_line_2: '',
        city: this.city,
        state: this.state,
        zip_code: this.zip,
        country: this.country
      })
        .then(res => {
          if (res.data) {
            res = res.data.result;
            this.mapCenter.lat = res.geometry.location.lat;
            this.mapCenter.lng = res.geometry.location.lng;
          }
          var clone = Object.assign({}, this.$data);
          delete clone.file;
          API.post(`user/adv-search`, clone)
            .then(res => {
              this.processResponse(res);
            })
            .catch(err => {
              console.log(err);
              this.overlay = false;
            });
        })
        .catch(err => {
          console.log(err);
          this.overlay = false;
        });
    },
    calculateMap() {
      if (this.$refs.themap.$mapObject) {
        this.mapCenter.lat = this.$refs.themap.$mapObject.getCenter().lat();
        this.mapCenter.lng = this.$refs.themap.$mapObject.getCenter().lng();
        let bounds = this.$refs.themap.$mapObject.getBounds();
        let ne = bounds.getNorthEast();
        let sw = bounds.getSouthWest();
        let hDist = this.distance(ne.lat(), sw.lng(), ne.lat(), ne.lng(), 'K');
        let vDist = this.distance(ne.lat(), sw.lng(), sw.lat(), sw.lng(), 'K');
        let radius = hDist / 2;
        if (hDist < vDist) {
          radius = vDist / 2;
        }
        this.mapRadius = radius * 1000;
      } else {
        setTimeout(() => {
          this.calculateMap();
        }, 500);
      }
    },
    resetManNSlider() {
      this.menRecipientsNumber = 0;
      this.$refs.manNSlider.setValue(0);
      this.manNSlider = {
        min: 0,
        max: 100,
        disabled: true
      };
      this.manNSliderData = {
        0: 0,
        100: '0'
      };
    },
    resetWomanNSlider() {
      this.womenRecipientsNumber = 0;
      this.$refs.womanNSlider.setValue(0);
      this.womanNSlider = {
        min: 0,
        max: 100,
        disabled: true
      };
      this.womanNSliderData = {
        0: 0,
        100: '0'
      };
    },
    resetMaleAgesSlider() {
      this.manSlider = {
        min: 10,
        max: 90,
        disabled: true
      };
      this.manSliderData = {
        10: 10,
        90: 90
      };
      this.menAgeRange = [10, 90];
    },
    resetFemaleAgesSlider() {
      this.womanSlider = {
        min: 10,
        max: 90,
        disabled: true
      };
      this.womanSliderData = {
        10: 10,
        90: 90
      };
      this.womenAgeRange = [10, 90];
    },
    fakeMaleAgesSlider(data) {
      this.manSlider.disabled = false;
      let min = data.maleAgeFrom;
      let max = data.maleAgeFrom + 1;
      this.manSlider = {
        min: min,
        max: max,
        disabled: true
      };
      this.manSliderData = {};
      this.manSliderData[min] = min;
      this.manSliderData[max.toString()] = min.toString();
      this.menRecipientsNumber = data.male;
    },
    fakeFemaleAgesSlider(data) {
      this.womanSlider.disabled = false;
      let min = data.femaleAgeFrom;
      let max = data.femaleAgeFrom + 1;
      this.womanSlider = {
        min: min,
        max: max,
        disabled: true
      };
      this.womanSliderData = {};
      this.womanSliderData[min] = min;
      this.womanSliderData[max.toString()] = min.toString();
      this.womenRecipientsNumber = data.female;
    },
    recalcMaleAgesSlider(data) {
      if (data.count === 0) {
        this.resetMaleAgesSlider();
        return;
      }
      this.manSliderData = {};
      if (data.maleAgeFrom === data.maleAgeTo) {
        this.menAgeRange = [data.maleAgeFrom, data.maleAgeTo];
        this.fakeMaleAgesSlider(data);
        return;
      }
      if (this.menAgeRange[0] === this.menAgeRange[1]) {
        this.menAgeRange = [data.maleAgeFrom, data.maleAgeTo];
      }
      if (this.menAgeRange[1] > data.maleAgeTo) {
        this.menAgeRange[1] = data.maleAgeTo;
      }
      this.manSlider['max'] = data.maleAgeTo;
      if (this.menAgeRange[1] < data.maleAgeFrom) {
        this.menAgeRange[1] = data.maleAgeFrom;
      }
      if (
        this.menAgeRange[0] < data.maleAgeFrom ||
        this.menAgeRange[0] > data.maleAgeTo
      ) {
        this.menAgeRange[0] = data.maleAgeFrom;
      }
      if (this.firstLoad) {
        this.menAgeRange[1] = data.maleAgeTo;
      }
      this.manSliderData[data.maleAgeFrom] = data.maleAgeFrom;
      this.manSliderData[data.maleAgeTo] = data.maleAgeTo;
      this.$refs.manSlider.setValue(this.menAgeRange);
      this.manSlider['min'] = data.maleAgeFrom;
      if (data.male > 0) {
        this.manSlider.disabled = false;
      }
    },
    recalcFemaleAgesSlider(data) {
      if (data.count === 0) {
        this.resetFemaleAgesSlider();
        return;
      }
      this.womanSliderData = {};
      if (data.femaleAgeFrom === data.femaleAgeTo) {
        this.womenAgeRange = [data.femaleAgeFrom, data.femaleAgeTo];
        this.fakeFemaleAgesSlider(data);
        return;
      }
      if (this.womenAgeRange[0] === this.womenAgeRange[1]) {
        this.womenAgeRange = [data.femaleAgeFrom, data.femaleAgeTo];
      }
      if (this.womenAgeRange[1] > data.femaleAgeTo) {
        this.womenAgeRange[1] = data.femaleAgeTo;
      }
      this.womanSlider['max'] = data.femaleAgeTo;
      if (this.womenAgeRange[1] < data.femaleAgeFrom) {
        this.womenAgeRange[1] = data.femaleAgeFrom;
      }
      if (
        this.womenAgeRange[0] < data.femaleAgeFrom ||
        this.womenAgeRange[0] > data.femaleAgeTo
      ) {
        this.womenAgeRange[0] = data.femaleAgeFrom;
      }
      if (this.firstLoad) {
        this.womenAgeRange[1] = data.femaleAgeTo;
      }
      this.womanSliderData[data.femaleAgeFrom] = data.femaleAgeFrom;
      this.womanSliderData[data.femaleAgeTo] = data.femaleAgeTo;
      this.$refs.womanSlider.setValue(this.womenAgeRange);
      this.womanSlider['min'] = data.femaleAgeFrom;
      if (data.female > 0) {
        this.womanSlider.disabled = false;
      }
    },
    recalcManNSlider(data) {
      if (data.count === 0) {
        this.resetManNSlider();
        return;
      }
      if (
        this.menRecipientsNumber > data.male ||
        this.menRecipientsNumber === this.manNSlider.max ||
        this.menRecipientsNumber === 0
      ) {
        this.menRecipientsNumber = data.male;
      }
      this.manNSlider.max = data.male;
      this.manNSlider.disabled = false;
      this.manNSliderData = {
        0: 0
      };
      this.manNSliderData[data.male] = data.male;
    },
    recalcWomanNSlider(data) {
      if (data.count === 0) {
        this.resetWomanNSlider();
        return;
      }
      if (
        this.womenRecipientsNumber > data.female ||
        this.womenRecipientsNumber === this.womanNSlider.max ||
        this.womenRecipientsNumber === 0
      ) {
        this.womenRecipientsNumber = data.female;
      }
      this.womanNSlider.max = data.female;
      this.womanNSlider.disabled = false;
      this.womanNSliderData = {
        0: 0
      };
      this.womanNSliderData[data.female] = data.female;
    },
    processResponse(res) {
      this.recalcMaleAgesSlider(res.data);
      this.recalcFemaleAgesSlider(res.data);
      this.recalcManNSlider(res.data);
      this.recalcWomanNSlider(res.data);
      if (this.firstLoad) {
        this.firstLoad = false;
      }
      this.overlay = false;
      this.recipientsCounts();
    },
    distance(lat1, lon1, lat2, lon2, unit) {
      if (lat1 === lat2 && lon1 === lon2) {
        return 0;
      } else {
        var radlat1 = (Math.PI * lat1) / 180;
        var radlat2 = (Math.PI * lat2) / 180;
        var theta = lon1 - lon2;
        var radtheta = (Math.PI * theta) / 180;
        var dist =
          Math.sin(radlat1) * Math.sin(radlat2) +
          Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit === 'K') {
          dist = dist * 1.609344;
        }
        if (unit === 'N') {
          dist = dist * 0.8684;
        }
        return dist;
      }
    },
    onChangeTab(type) {
      this.coordType = type;
    },
    updateCenter() {
      this.calculateMap();
    },
    updateBounds() {
      this.calculateMap();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.file = files[0];
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result;
        });
      }
    },
    async submitFile() {
      /*
              Initialize the form data
          */
      let formData = new FormData();

      /*
          Add the form data we need to submit
      */
      formData.append('file', this.file);

      /*
        Make the request to the POST /single-file URL
      */
      let res = await API.post('advertisment/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return res.data.uuid;
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: black;
  z-index: 1000;
  top: 0;
  left: 0;
  opacity: 0.3;
}
.tab-pane {
  padding: 15px;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-radius: 3px;
  margin-bottom: 25px;
}

.tab-pane input,
input,
textarea {
  margin: 0 0 15px 0;
  /*width: 80%;*/
}
#card-element {
  width: 360px;
  height: 40px;
  display: block;
  margin: 15px 0 25px 5px;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding-top: 10px;
  padding-left: 5px;
}
</style>
